// dependencies
import { useEffect } from "react";

// utils
import pubSub from "../utils/PubSub";

const useSubscribe = (subscriptionName, action) => {
	useEffect(() => {
		const subscription = pubSub.subscribe(subscriptionName, action);

		return function cleanup() {
			subscription.remove();
		};
	});
};

export default useSubscribe;
